module.exports = "/dashboard/manage/users/wagesHistory-453221.html";